import { ChangeEvent } from 'react';
import { FormInterface } from '../../../core/interfaces/form/Form';
import FormLabel from '../../../component/input/FormLabel.component';
import { FormSelect } from '../../../component/input/InputStyle';
import MenuItem from '@material-ui/core/MenuItem';
import CardComponent from '../../../component/card/Card.component';

export default function Form({ handleSubmitForm, initialValues }: FormInterface<string>) {

    const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
        const { value } = event.target;
        handleSubmitForm(String(value).toUpperCase());
    }

    return (
        <form>
            <CardComponent padding="14px 20px 10px 20px">
                <FormLabel title="Pesquisar por" sm={12}>
                    <FormSelect
                        name="search"
                        value={initialValues}
                        onChange={handleChange}
                        defaultValue="0"
                        required
                    >
                        <MenuItem value="0" >Descrição / Código SAP</MenuItem>
                        <MenuItem value="1">EAN do produto</MenuItem>
                    </FormSelect>
                </FormLabel>
            </CardComponent>
        </form>
    )
}
